"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOldPrice = void 0;
var _presentationUtils = require("@ori/presentation-utils");
const getOldPrice = ({
  formattedPrice
}) => {
  const {
    basicCataloguePrice,
    currentPrice
  } = formattedPrice?.price ?? {};
  return basicCataloguePrice && currentPrice && (0, _presentationUtils.parseNumberFromString)(basicCataloguePrice) > (0, _presentationUtils.parseNumberFromString)(currentPrice) ? basicCataloguePrice : null;
};
exports.getOldPrice = getOldPrice;
